import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import {
  SectionAlternate,
  CardBase,
  Hero,
  DataListAndRowView,
  FormComponent
} from "@components/organisms";
import moment from "moment";

import { useLocation } from "react-router-dom";

//redux
import { useSelector } from "react-redux";

//API Requests
import { ConnectService } from "@services";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
  },
  section: {
    "& .section-alternate__content": {
      paddingTop: 0,
      marginTop: theme.spacing(-5),
      position: "relative",
      zIndex: 1,
    },
    "& .card-base__content": {
      padding: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3),
      },
    },
  },
}));

const Forms = (props = {}) => {
  const classes = useStyles();
  //redux
  const { user } = useSelector((state) => state.user);
  const { currentCounty } = useSelector((state) => state.counties);

  //Set variable
  const [loading, setLoading] = React.useState(false);
  const [fetchedData, setFetchedData] = React.useState([]);
  const [currentSelectedForm, setCurrentSelectedForm] = React.useState(null);

    // the query string for you.
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();

  //onPageLoad
  React.useEffect(() => {
    setLoading(true);

    let currentState = query.get("state");
    let currentCounty = query.get("county");

    ConnectService.getFormsList(currentState,currentCounty)
      .then((data) => {
        setLoading(false);
        setFetchedData(data.forms);
      })
      .catch((err) => {
        alert(JSON.stringify(err));
        setLoading(false);
      });
  }, []);


  const onFormSelected = (selectedForm) => {
    setLoading(true);
    //sample api GET request
    ConnectService.getFormByKey(selectedForm.formKey)
      .then((data) => {
        setLoading(false);
        setCurrentSelectedForm(data.form);
      })
      .catch((err) => {
        alert(JSON.stringify(err));
        setLoading(false);
      });
  }
  
  const onSubmitFormPDF = async (formBase64String,formContents) => {
    setLoading(true);
    
    let dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
    let localTime = new Date();
    let localTimezone = new Date().toString().match(/\(([A-Za-z\s].*)\)/)[1];


    const payload = {
      "formKey": currentSelectedForm.formKey,
      "empNum": user.employeeNumber,
      "firstName": user.firstName,
      "lastName": user.lastName,
      "state": currentCounty.state,
      "county": currentCounty.county,
      "submittedBy": user.employeeNumber,
      "pdfBase64": formBase64String ? formBase64String.replace("data:application/pdf;filename=generated.pdf;base64,", "") : null,
      "businessUnit": user.businessUnit,
      "documentTypeID": currentSelectedForm.documentTypeID,
      "documentType": currentSelectedForm.documentType,
      "formContents": formContents,
      "UTCDateTime": localTime.toUTCString(),
      "actionStatus": "Submitted",
      "countyName": currentCounty.county,
      "formStyle": currentSelectedForm.formKey,
      "localDateTime": localTime.toLocaleDateString("en-US", dateOptions),
      "timeZone": localTimezone,
      "createdBy": `${user.firstName} ${user.lastName} (${user.employeeNumber})`,
    };

    const otherFormPayloads = {
      "UTCDateTime": moment.utc(localTime).format('llll'),
      "actionStatus": "Submitted",
      "businessUnit": user.businessUnit,
      "countyName": currentCounty.county,
      "formContents": formContents,
      "formKey": currentSelectedForm.formKey,
      "formStyle": currentSelectedForm.formKey,
      "localDateTime": localTime,
      "state": currentCounty.state,
      "submittedBy": user.employeeNumber,
      "timeZone": localTimezone
    }

    if(currentSelectedForm.formKey.toLowerCase() === "mdcscrndct") {
          return ConnectService.submitPDFForm(currentSelectedForm.formKey,payload)
          .then((data) => {
            alert("Form Submitted Successfully");
            setLoading(false);
            setCurrentSelectedForm(null);
            return true;
          })
          .catch((err) => {
            alert("An error occurred, Please try resubmitting..");
            setLoading(false);
            return false;
          });
    } else {
        return ConnectService.submitForm(otherFormPayloads)
        .then((data) => {
          alert("Form Submitted Successfully");
          setLoading(false);
          setCurrentSelectedForm(null);
          return true;
        })
        .catch((err) => {
          alert("An error occurred, Please try resubmitting..");
          setLoading(false);
          return false;
        });
    }
  }



  return (
    <div className={classes.root}>
      <Hero title={"Forms"} subtitle={""} />
      <SectionAlternate className={classes.section}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={12}>
            <CardBase withShadow align="left">
              {/* COMPONENTS CONTENT GO HERE*/}

              { !currentSelectedForm && <DataListAndRowView
                isLoading={loading}
                emptyStateText={"There are currently no Forms to display"}
                fetchedData={fetchedData}
                mainDisplayColumns={["formName"]}
                altDisplayColumn={null}
                isForm={true}
                onRowSelected={onFormSelected}
                hasFilter
              /> }

              { currentSelectedForm && <FormComponent currentForm={currentSelectedForm} submitFormPDF={onSubmitFormPDF} />}
              
            </CardBase>
          </Grid>
        </Grid>
      </SectionAlternate>
    </div>
  );
};

export default Forms;
